/**
 * Mock data for the Finance Calendar Widget
 * Represents Guidance Planning cycle events
 */

export interface FinanceCalendarFromS3 {
  scenario: string;
  date_time: string;
  event: string;
  description: string;
}

export const financeCalendarMockData: FinanceCalendarFromS3[] = [
  // === March 11 (Today) ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-12T10:00:00',
    event: '1st Pass: Remorse Return Units',
    description: '1st pass: Remorse return units loaded to VISTA'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-12T10:00:00',
    event: '1st Pass: Kids+ Warranty & Subscription Review',
    description: '1st Pass: Kids+ team to review standalone warranty and subscription inputs'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-12T10:00:00',
    event: '1st Pass: Ship-to-Order Rate',
    description: '1st pass: Ship-to-order rate %age loaded to VISTA based on prior year actuals'
  },

  // === March 13 ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-14T10:00:00',
    event: '2nd Pass: VISTA Open for 1P Units & Promo',
    description: '2nd pass: VISTA open for 1P Device Units and Promo Planning'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-14T10:00:00',
    event: '1st Pass: BOM Loaded to VISTA',
    description: '1st pass: BOM loaded to VISTA including Warranty/FR BOM'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-13T10:00:00',
    event: '1st Pass: All Other VISTA Inputs Due',
    description: '1st pass: All remainder other VISTA financial inputs due'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-14T12:00:00',
    event: 'Prophecy & xPT Tool Open',
    description: 'Prophecy (HC, OpEx, CapEx) and xPT Tool Open for Guidance Planning'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-14T17:00:00',
    event: 'WC: 1st Pass Shipment Units & WOC',
    description: 'WC - 1st pass shipment units and WOC'
  },

  // === March 16 ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-16T10:00:00',
    event: '1st Pass: GP P&L Snapshot',
    description: '1st Pass: GP P&L snapshot in Prophecy'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-16T10:00:00',
    event: '1st Pass: Guidance vs MEC GP Bridge',
    description: '1st Pass: Guidance vs. MEC GP Bridge Publish (informational only)'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-16T17:00:00',
    event: 'WC: 1st Pass Inventory BOM Due',
    description: 'WC: 1st Pass Inventory production BOM due'
  },

  // === March 17 ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-17T17:00:00',
    event: '2nd Pass: Axiom Inputs to VISTA',
    description: '2nd pass: All Axiom unit/promo inputs pushed into Vista'
  },

  // === March 18 ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-18T10:00:00',
    event: 'WC: Inventory Forecast Review Meeting',
    description: 'WC: Inventory forecast review meeting'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-18T10:00:00',
    event: '2nd Pass: VISTA Units Lock & Promotions',
    description: '2nd pass: VISTA units lock and promotions'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-18T10:00:00',
    event: 'Guidance vs MEC Live GP Bridge Published',
    description: 'Q2 Guidance vs MEC and FY Guidance vs MEC Live GP Bridge Published'
  },

  // === March 19 ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-19T12:00:00',
    event: 'D&S Guidance Daily Flash Begins',
    description: 'D&S Guidance Daily Flash Begins'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-19T14:00:00',
    event: '2nd Pass: All Other Unit Inputs Due',
    description: '2nd pass: All other unit Inputs due in VISTA and Prophecy'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-19T17:00:00',
    event: 'WC: 2nd Pass Shipped-In Units Due',
    description: 'WC: 2nd Pass Inventory shipped-in units due'
  },

  // === March 23 ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-23T10:00:00',
    event: '2nd Pass: BOM Loaded to VISTA',
    description: '2nd pass: BOM loaded to VISTA including warranty/FR BOM'
  },

  // === March 24 ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-24T10:00:00',
    event: '2nd Pass: Shipping & Import Duty Loaded',
    description: '2nd Pass: Inbounding Shipping and Import Duty Loaded'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-24T10:00:00',
    event: '2nd Pass: All VISTA & Prophecy Loads Due',
    description: '2nd Pass: All VISTA inputs & Direct to Prophecy Loads due'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-24T17:00:00',
    event: 'WC: Unearned Revenue Forecast Due',
    description: 'WC: Kids+, eero, Alexa+: 2nd Pass Balance sheet Unearned Revenue forecast due'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-24T17:00:00',
    event: 'WC: IPR Forecast Due',
    description: 'WC: IPR Forecast due'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-24T17:00:00',
    event: 'WC: Inbound Freight & Tariffs Due',
    description: 'WC: DGL and eero: Inbound freight cost and Tariffs of shipped-in inventory'
  },

  // === March 25 ===
  {
    scenario: 'Guidance',
    date_time: '2026-03-25T10:00:00',
    event: 'WC: Commentary Due from DSO & Stakeholders',
    description: 'WC: Commentary due from DSO and other stakeholders in the sharepoint doc'
  },
  {
    scenario: 'Guidance',
    date_time: '2026-03-25T10:00:00',
    event: '2nd Pass: GP P&L Snapshot',
    description: '2nd Pass: GP P&L snapshot in Prophecy'
  },

  // ══════════════════════════════════════════════════════════
  // MEC Scenario
  // ══════════════════════════════════════════════════════════

  {
    scenario: 'MEC',
    date_time: '2026-04-07T10:00:00',
    event: 'MEC Kickoff & Planning Calendar Published',
    description: 'MEC planning cycle kickoff meeting and calendar published to stakeholders'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-07T10:00:00',
    event: 'VISTA Open for MEC Unit Inputs',
    description: 'VISTA open for MEC 1P Device unit inputs and promo planning'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-10T10:00:00',
    event: '1st Pass: BOM Loaded to VISTA',
    description: '1st pass: BOM loaded to VISTA including Warranty/FR BOM for MEC'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-10T12:00:00',
    event: 'Prophecy & xPT Tool Open for MEC',
    description: 'Prophecy (HC, OpEx, CapEx) and xPT Tool Open for MEC Planning'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-14T10:00:00',
    event: '1st Pass: GP P&L Snapshot in Prophecy',
    description: '1st Pass: GP P&L snapshot in Prophecy for MEC'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-14T10:00:00',
    event: '1st Pass: MEC vs Guidance GP Bridge Publish',
    description: '1st Pass: MEC vs. Guidance GP Bridge Publish (informational only)'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-17T17:00:00',
    event: '2nd Pass: All Axiom Inputs to VISTA',
    description: '2nd pass: All Axiom unit/promo inputs pushed into VISTA for MEC'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-21T10:00:00',
    event: '2nd Pass: VISTA Units Lock & Promotions',
    description: '2nd pass: VISTA units lock and promotions for MEC'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-21T10:00:00',
    event: 'MEC vs Guidance Live GP Bridge Published',
    description: 'Q2 MEC vs Guidance and FY MEC vs Guidance Live GP Bridge Published'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-24T10:00:00',
    event: '2nd Pass: All VISTA & Prophecy Loads Due',
    description: '2nd Pass: All VISTA inputs & Direct to Prophecy Loads due for MEC'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-24T17:00:00',
    event: 'WC: Balance Sheet & Unearned Revenue Due',
    description: 'WC: Kids+, eero, Alexa+: 2nd Pass Balance sheet Unearned Revenue forecast due for MEC'
  },
  {
    scenario: 'MEC',
    date_time: '2026-04-28T10:00:00',
    event: '2nd Pass: GP P&L Snapshot',
    description: '2nd Pass: GP P&L snapshot in Prophecy for MEC'
  },
  {
    scenario: 'OP',
    date_time: '00',
    event: '',
    description: ''
  }
];
